// extracted by mini-css-extract-plugin
export default {"pageAlert":"pageAlert_c87f2"};